// 2nd param set false if you do not want to trigger VirtualPageView
export function setAndTriggerDataLayer(data, pushDataLayer = true) {
    if (typeof window !== 'undefined') {
        const newDataLayer = { ...window.persistDataLayer, ...data, event: 'VirtualPageView' };
        const { visitorEmail, visitorMobile, gaMobile, userType } = newDataLayer;
        window.persistDataLayer = { visitorEmail, visitorMobile, gaMobile, userType };
        if (pushDataLayer) {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push(newDataLayer);
            } else {
                setTimeout(() => {
                    setAndTriggerDataLayer(data, pushDataLayer);
                }, 2000);
            }
        }
    }
}

export function pushDataLayerEvent(data) {
    if (typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined') {
        const { gaMobile, userType } = window.persistDataLayer;
        data = { ...data, mobile: gaMobile, userType };
        window.dataLayer.push(data);
    } else {
        setTimeout(() => {
            pushDataLayerEvent(data);
        }, 2000);
    }
}
